// React
import React from "react";
import { render } from "react-dom";
// Redux
import { createStore } from "redux";
import { Provider } from "react-redux";
// Router
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
// UI
import { MuiThemeProvider } from "material-ui/styles";
import "babel-polyfill";
// Reducer
import reducers from "./redux/reducers";
// Component
import App from "./App";
// MUI theme
import theme from "./theme";
// Style
import "./index.css";

/* eslint-disable no-underscore-dangle */
const store = createStore(
  reducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
/* eslint-enable */

render(
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      <Router>
        <Switch>
          <Route path="/" component={App} />
        </Switch>
      </Router>
    </MuiThemeProvider>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js